import React, { Component } from "react";
import moment from "moment";
import axios from "./../../../axios";
import * as url from "./../../../utils/url";
import { connect } from "react-redux";
import Loading from "../../../hoc/Loading/Loading";
import Paginations from "./metaPaginations";
import size from "lodash/size";
import {  Button } from "reactstrap";
import CheckBox from "rc-checkbox";
import { formatCamelCase,fieldOptionsArray } from "../../../utils/constants.js";
import "./metaDataHistory.css";

class ImportHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      currentPage: 1,
      recordCount: 10,
      totalCount: 0,
      showMore: false,
    };
  }

  componentDidMount() {
    this.fetchData(this.state.currentPage, this.state.recordCount);
    document.documentElement.classList.add("allow-page-horizontal-scroll");
    document.body.classList.add("allow-page-horizontal-scroll");
  }

  componentWillUnmount() {
    document.documentElement.classList.remove("allow-page-horizontal-scroll");
    document.body.classList.remove("allow-page-horizontal-scroll");
  }

  fetchData = (page, limit) => {
    axios
      .get(url.getAllOrgUserMetaData, {
        params: { page, limit },
      })
      .then(({ data }) => {
        const history = data.data.data.map((item) => ({
          ...item,
          typeInfo: item.typeInfo || [],
        }));
        this.setState({
          history,
          totalCount: data.data.totalCount,
          currentPage: page,
          recordCount: limit,
        });
      });
  };

  handleCheckboxChange = (itemIndex, keyIndex) => {
    const updatedHistory = [...this.state.history];
    const current = updatedHistory[itemIndex].typeInfo[keyIndex];

    current.isActive = !current.isActive;
    this.setState({ history: updatedHistory });

    console.log('Starting metadata update request to:', url.updateAllOrgUserMetaData);
    console.log('Request payload:', {
      metaId: updatedHistory[itemIndex]._id,
      fieldName: current.fieldName,
      isActive: current.isActive,
    });
    // Replace this URL with your actual backend endpoint
    axios
      .post(url.updateAllOrgUserMetaData, {
        metaId: updatedHistory[itemIndex]._id,
        fieldName: current.fieldName,
        isActive: current.isActive,
      })
      .then(() => {
        console.log('Metadata update completed successfully');
      })
      .catch((err) => {
        console.error("Failed to update flag:", err);
      });
  };


  // onViewClick = async (e, id, model, { inline = false } = {}) => {
  //   e.preventDefault();
  
  //   try {
  //     const res = await axios.get(url.getSignedUrl, {
  //       params: {
  //         id,
  //         model,                          // e.g., "OrgUserMetadata", exactly your Mongoose model name
  //         inline: inline ? 1 : 0,
  //       },
  //     });

  //     console.log('res 90 --- ', res)
  
  //     const { url: signedUrl } = res.data;
  
  //     // If you want to open in a new tab (view inline), remove the `download` attr on <a> and do:
  //     // if (inline) return window.open(signedUrl, '_blank');
  
  //     // Keep your current anchor behavior (download):
  //     e.currentTarget.href = signedUrl;
  //     e.currentTarget.click();
  //     // Optional: reset href
  //     e.currentTarget.href = '#';
  //   } catch (err) {
  //     console.error('Failed to get signed URL', err);
  //     // TODO: show toast/snackbar
  //   }
  // };
  
  onViewClick = async (e, id, model, { inline = false } = {}) => {
    e.preventDefault();
  
    try {
      const { data } = await axios.get(url.getSignedUrl, {
        params: { id, model, inline: inline ? 1 : 0 },
      });
  
      console.log('115 --- ', data)
      const signedUrl = data.url;
      if (!signedUrl) throw new Error('No signed URL returned');
  
      // Open in a NEW tab and trigger download (filename comes from S3 Content-Disposition)
      const a = document.createElement('a');
      a.href = signedUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.download = ''; // hint download; server header decides filename
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {
      console.error('Failed to get signed URL', err);
    }
  };

  handlePageNavigation = (directionOrPage) => {
    const { currentPage, recordCount, totalCount } = this.state;
    const totalPageNumber = Math.ceil(totalCount / recordCount);
    let newPage = currentPage;

    if (directionOrPage === "next" && currentPage < totalPageNumber) newPage++;
    else if (directionOrPage === "previous" && currentPage > 1) newPage--;
    else if (directionOrPage === "first") newPage = 1;
    else if (directionOrPage === "last") newPage = totalPageNumber;
    else if (typeof directionOrPage === "number") newPage = directionOrPage;

    if (newPage !== currentPage) {
      this.fetchData(newPage, recordCount);
    }
  };

  handleRecordCountChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    this.fetchData(1, newLimit);
  };


  generatePageNumbers = () => {
    const { currentPage, recordCount, totalCount } = this.state;
    const totalPageNumber = Math.ceil(totalCount / recordCount);
    const pages = [];
    for (let i = 1; i <= totalPageNumber; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <span
            className="page-link"
            onClick={() => this.fetchData(i, recordCount)}
          >
            {i}
          </span>
        </li>
      );
    }
    return pages;
  };

  navigateToUploadData = () => {
    if (this.props.user.orgAdmin) {
      this.props.history.push("/home/users");
    }
  };



  renderList = (list) => {
    
    if (list && list.length > 0) {

      
      console.log("List:", list);
      return list.map((item, index) => {
        const { showMore } = this.state;
        const displayList = showMore
          ? item.typeInfo.filter(
              (field) => !fieldOptionsArray.includes(field.fieldName)
            )
          : item.typeInfo
              .filter((field) => !fieldOptionsArray.includes(field.fieldName))
              .slice(0, 10);
        const columnsList = showMore
          ? item.columnNames.filter(
              (column) => !fieldOptionsArray.includes(column)
            )
          : item.columnNames
              .filter((column) => !fieldOptionsArray.includes(column))
              .slice(0, 10);
  

  if(fieldOptionsArray.includes(displayList.fieldName)) return;

        return (
          <tr key={index}>
            <td>
              {item.fileName ? (
                <p>
                  {item.fileName}
                  <a href="#" onClick={(e) => this.onViewClick(e, item._id, 'OrgUserMetadata')}>
                    &nbsp; (view File)
                  </a>
                </p>
              ) : (
                <p>
                  File Uploaded: ${moment(item.uploadedAt).format("MM/DD/YYYY")}
                </p>
              )}
            </td>
            <td>{moment(item.uploadedAt).format("MM/DD/YYYY, h:mm:ss a")}</td>
            <td>{item.uploadedBy || ''}</td>
            <td>{item.numUsers}</td>
            <td>{item.usersAdded || 0}</td>
            <td>{item.usersUpdated || 0}</td>
            <td>{item.usersDeactivated || 0}</td>
            <td>
              {columnsList.map((key) => (
                <p key={key}>{formatCamelCase(key)}</p>
              ))}
            </td>
            <td>
              {displayList.map((key, k) => (
                <p key={k}>
                  <CheckBox
                    checked={key.isActive}
                    onChange={() => this.handleCheckboxChange(index, k)}
                  />
                </p>
              ))}
              {item.typeInfo.length > 10  && (

                <a
                onClick={() => this.setState({ showMore: !showMore })}
                style={{
                  cursor: "pointer",
                  color: "#007bff",
                  textDecoration: "underline",
                }}
                >
                {showMore ? "Show Less" : "Show More"}
              </a>
              )}
            </td>
          </tr>
        );});
    }

    return (
      <tr>
        <td>
          No imports found.
          {this.props.user.orgAdmin && (
            <span>
              {" "}
              Please <span onClick={this.navigateToUploadData}>
                click here
              </span>{" "}
              to upload data.
            </span>
          )}
        </td>
      </tr>
    );
  };

  render() {
    const { history, currentPage, recordCount, totalCount } = this.state;
    const totalPageNumber = Math.ceil(totalCount / recordCount);
    console.log("History:", history);
    

    return (
      <div className="ent-settings-data-history">
        <div className="mt30">
          <div className="title-text">Upload History</div>
        </div>
        <hr />
        <div className="mt40 mb10 org-chart-description-text">
          See a list of your organization's metadata upload history.
        </div>

        <div>
          <div className="user-import-history-scroll mt-3 mb-2 table-ellipsis">
            <table
              className="toolkit-list table text-primary-color tool-list-font"
              style={{ borderTop: "0px" }}
            >
              <thead>
                <tr className="col-sm-4 mb-3">
                  <th className="bottom-border-color borderTop0">File Name</th>
                  <th className="bottom-border-color borderTop0">Time Stamp</th>
                  <th className="bottom-border-color borderTop0">By</th>
                  <th className="bottom-border-color borderTop0">
                    Users in File
                  </th>
                  <th className="bottom-border-color borderTop0">Users Added</th>
                  <th className="bottom-border-color borderTop0">Users Updated</th>
                  <th className="bottom-border-color borderTop0">Users Deactivated</th>
                  <th className="bottom-border-color borderTop0">Fields</th>
                  <th className="bottom-border-color borderTop0">
                    Is Active
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderList(history)}</tbody>
            </table>
          </div>

          <Paginations
            currentPage={currentPage}
            totalPageNumber={totalPageNumber}
            handlePageNavigation={this.handlePageNavigation}
            Analytics={history}
            generatePageNumbers={this.generatePageNumbers}
            handleRecordCountChange={this.handleRecordCountChange}
            recordCount={recordCount}
            totalRecords={totalCount}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Loading(ImportHistory, axios));
